export class PaymentProcessBackingRequest {
    public affiliateDocumentType: string;
    public affiliateDocument: number;
    public claimedValue: number;
    public deductiblePercentage: number;
    public draftNumber: string;
    public filingNumber: number;
    public filingStatus: string;
    public guaranteedValue: number;
    public issuerDocumentType: string;
    public issuerDocument: number;
    public newPayment: number;
    public recoveryValue: number;
    public returnCause: string;
    public sinisterProduct: string;
    public user: string;
}